import { Routes, mapToCanActivate } from "@angular/router";
import { AboutComponent } from "./about/about.component";
import { AccessDeniedComponent } from './access-denied/access-denied.component';
import { AccessGuard } from "./access.guard";
import { AcknowledgementsComponent } from "./acknowledgements/acknowledgements.component";
import { AuthGuard } from "./auth.guard";
import { CompanyManagementComponent } from "./company-management/company-management.component";
import { HomeComponent } from "./home/home.component";
import { LoginComponent } from "./login/login.component";
import { MockupPageComponent } from "./mockup-page/mockup-page.component";
import { UserManagementComponent } from './user-management/user-management.component';

// Always provide a name for the route so that name can be used by the breadcrumb component
export const routes: Routes = [
  {
    path: "home",
    data: {
      name: "Home",
    },
    canActivate: mapToCanActivate([AuthGuard]),
    component: HomeComponent,
    children: [],
  },
  {
    path: "login",
    component: LoginComponent,
  },
  {
    path: "about",
    component: AboutComponent,
    canActivate: mapToCanActivate([AuthGuard]),
  },
  {
    path: "acknowledgements",
    component: AcknowledgementsComponent
  },
  {
    path: 'afirs-analytics',
    component: MockupPageComponent,
  },
  {
    path: 'clear-port',
    component: MockupPageComponent,
  },
  {
    path: 'access-denied',
    component: AccessDeniedComponent,
  },
  {
    path: 'user-management',
    data:
    {
      name: 'User Management'
    },
    canActivate: mapToCanActivate([AuthGuard, AccessGuard]),
    children: [
      {
        path: '',
        redirectTo: 'company',
        pathMatch: 'full'
      },
      {
        path: 'company',
        component: CompanyManagementComponent,
        canActivate: [AuthGuard]
      },
      {
        path: 'user',
        canActivate: [AuthGuard],
        component: UserManagementComponent,
      }
    ],
  },
  //
  {
    // Must be last in the array
    path: "**",
    redirectTo: "/home",
  }, // Must be last in the array
];